import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

export default function Spellcheck(props:any) {
  return (
    <SvgIcon {...props}>
      <path d="M12 2L4 5v6c0 5 4 9 8 9s8-4 8-9V5l-8-3zm-1 14l-4-4 1.41-1.41L11 13.17l6.59-6.59L19 8l-8 8z" />
    </SvgIcon>
  )
}
